// @flow

export default function isPointGeotype(geoType: ?string) {
  return (
    geoType &&
    ![
      'country',
      'administrative_area_level_1',
      'colloquial_area',
      'undefined_country_geocodes'
    ].includes(geoType)
  );
}
